if (!customElements.get('km-preview-gallery')) {
  customElements.define(
    'km-preview-gallery',
    class KmPreviewGallery extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;

        this.triggers = Array.from(this.querySelectorAll('[data-km-preview-trigger]')).filter(
          (trigger) => trigger.dataset.fullSrc
        );
        this.dialog = this.querySelector('[data-km-preview-lightbox]');
        if (!this.dialog || this.triggers.length === 0) return;

        this.initialized = true;
        this.stage = this.dialog.querySelector('[data-km-preview-stage]');
        this.figure = this.dialog.querySelector('[data-km-preview-figure]');
        this.image = this.dialog.querySelector('[data-km-preview-image]');
        this.caption = this.dialog.querySelector('[data-km-preview-caption]');
        this.closeButton = this.dialog.querySelector('[data-km-preview-close]');
        this.previousButton = this.dialog.querySelector('[data-km-preview-previous]');
        this.nextButton = this.dialog.querySelector('[data-km-preview-next]');
        this.currentIndex = 0;
        this.touchStart = null;

        this.triggers.forEach((trigger, index) => {
          trigger.addEventListener('click', () => this.open(index, trigger));
        });
        this.closeButton.addEventListener('click', () => this.close());
        this.previousButton.addEventListener('click', () => this.show(this.currentIndex - 1));
        this.nextButton.addEventListener('click', () => this.show(this.currentIndex + 1));
        this.dialog.addEventListener('click', (event) => {
          if (event.target === this.dialog || event.target === this.stage || event.target === this.figure) this.close();
        });
        this.stage.addEventListener('touchstart', (event) => this.onTouchStart(event), { passive: true });
        this.stage.addEventListener('touchend', (event) => this.onTouchEnd(event), { passive: true });
        this.handleKeydown = (event) => this.onKeydown(event);

        const hasNavigation = this.triggers.length > 1;
        this.previousButton.hidden = !hasNavigation;
        this.nextButton.hidden = !hasNavigation;
      }

      disconnectedCallback() {
        document.removeEventListener('keydown', this.handleKeydown);
        document.documentElement.classList.remove('km-preview-lightbox-open');
        document.body.classList.remove('km-preview-lightbox-open');
      }

      open(index, trigger) {
        this.lastTrigger = trigger;
        this.show(index);
        this.dialog.hidden = false;
        document.documentElement.classList.add('km-preview-lightbox-open');
        document.body.classList.add('km-preview-lightbox-open');
        document.addEventListener('keydown', this.handleKeydown);
        requestAnimationFrame(() => {
          this.dialog.classList.add('is-open');
          this.closeButton.focus({ preventScroll: true });
        });
      }

      close({ restoreFocus = true } = {}) {
        if (this.dialog.hidden) return;
        this.dialog.classList.remove('is-open');
        this.dialog.hidden = true;
        this.image.removeAttribute('src');
        document.removeEventListener('keydown', this.handleKeydown);
        document.documentElement.classList.remove('km-preview-lightbox-open');
        document.body.classList.remove('km-preview-lightbox-open');
        if (restoreFocus && this.lastTrigger) this.lastTrigger.focus({ preventScroll: true });
      }

      show(index) {
        this.currentIndex = (index + this.triggers.length) % this.triggers.length;
        const trigger = this.triggers[this.currentIndex];
        this.image.src = trigger.dataset.fullSrc;
        this.image.alt = trigger.dataset.alt || 'Podgląd strony e-booka';
        this.caption.textContent = trigger.dataset.caption || '';
      }

      onKeydown(event) {
        if (event.key === 'Escape') {
          event.preventDefault();
          this.close();
          return;
        }
        if (event.key === 'ArrowLeft' && this.triggers.length > 1) {
          event.preventDefault();
          this.show(this.currentIndex - 1);
          return;
        }
        if (event.key === 'ArrowRight' && this.triggers.length > 1) {
          event.preventDefault();
          this.show(this.currentIndex + 1);
          return;
        }
        if (event.key !== 'Tab') return;

        const controls = [this.closeButton, this.previousButton, this.nextButton].filter(
          (control) => control && !control.hidden
        );
        const first = controls[0];
        const last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault();
          last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault();
          first.focus();
        }
      }

      onTouchStart(event) {
        const touch = event.changedTouches[0];
        this.touchStart = { x: touch.clientX, y: touch.clientY };
      }

      onTouchEnd(event) {
        if (!this.touchStart || this.triggers.length < 2) return;
        const touch = event.changedTouches[0];
        const deltaX = touch.clientX - this.touchStart.x;
        const deltaY = touch.clientY - this.touchStart.y;
        this.touchStart = null;
        if (Math.abs(deltaX) < 45 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
        this.show(deltaX < 0 ? this.currentIndex + 1 : this.currentIndex - 1);
      }
    }
  );
}
